import { marqueeConfig, partners } from '../data/partners';
import { useAnalytics } from '../hooks/useAnalytics';
import { Container, Section, SectionHeader } from './atomic';
import { PartnerMarquee } from './molecules';

/**
 * The Collective section component that showcases RSM Collective's partners.
 *
 * This component displays:
 * - A scrolling marquee of partner logos
 * - Strategic CTA buttons between partner groups
 * - Responsive design with smooth animations
 *
 * The component is now data-driven, making it easy to add or remove partners
 * by simply updating the partners data array.
 *
 * @returns {JSX.Element} The Collective section with partner marquee
 */
function TheCollective() {
  const { trackCTA } = useAnalytics();

  /**
   * Handle CTA button clicks for analytics tracking
   */
  const handleCtaClick = () => {
    // Track the CTA click using centralized analytics
    trackCTA('partner_marquee', 'Join Us', {
      section: 'our_community',
      partner_count: partners.length,
    });
  };

  return (
    <Section
      dark
      sx={{
        backgroundColor: 'var(--color-secondary)',
        backgroundImage:
          'url(https://images.unsplash.com/photo-1622675363311-3e1904dc1885?w=1600&h=800&fit=crop&crop=center)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        py: 0,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(26, 26, 26, 0.85)',
          zIndex: 0,
        },
        '& > *': {
          position: 'relative',
          zIndex: 1,
        },
      }}
    >
      <SectionHeader title="Our Community" dark />

      <Container maxWidth="lg" sx={{ pb: 8 }}>
        {/* Partner Marquee - Data-driven scrolling display */}
        <PartnerMarquee
          partners={partners}
          config={marqueeConfig}
          onCtaClick={handleCtaClick}
        />
      </Container>
    </Section>
  );
}

export default TheCollective;
